import { render, staticRenderFns } from "./HighscoresButtons.vue?vue&type=template&id=5a91afb7&"
import script from "./HighscoresButtons.vue?vue&type=script&lang=js&"
export * from "./HighscoresButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports